import React,{ useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { useAppContext } from "../../services/context";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import { getPaginatedNotifs } from "../../services/axios/apiManager";
import NotificationsList from "./notificationsList";

const ManageNotifications = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  const [notifications, setNotifications] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Notifications");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await getPaginatedNotifs();
    if (res?.data?.success && res?.data?.data) {
      setNotifications(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Providers List:");
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div data-testid="manage-notifications">
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>System Settings</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#8b8b8cbf" }}
                >
                  Notifications
                </li>
              </ol>
            </div>
          </div>
        </div>

        <NotificationsList
          notifications={notifications}
          setNotifications={setNotifications}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default ManageNotifications;
